import { Ng2StateDeclaration } from '@uirouter/angular';
import { Transition } from '@uirouter/core';

import { AdminUsersViewComponent } from './users/admin.users.component';
import { AdminUserEditComponent } from './user-edit/admin.user-edit.component';
import { AdminUserAddComponent } from './user-add/admin.user-add.component';
import { SiteAdminOrgsView } from './orgs/admin.orgs.component';
import { OrgMembersAuditComponent } from './orgs/orgMembersAudit/org.members-audit.component';
import { AdminConfigComponent } from './config/admin.config.component';
import { SiteAdminHomepageComponent } from './siteAdminHomepage/site.admin.homepage.component';
import { SiteAdminScmComponent } from './scm/admin.scm.component';
import { SiteAdminCronjobsComponent } from './cronjobs/admin.cronjobs.component';
import { AdminTroveViewComponent } from './trove/admin.trove.component';
import { AdminProjectsViewComponent } from './projects/admin.projects.component';
import { AdminGroupViewComponent } from './groups/admin.groups.component';
import { AdminSnapshotsViewComponent } from './snapshots/admin.snapshots.component';
import { SiteSummaryReportComponent } from './reports/summary/reports.summary.component';
import { SiteCronHistoryComponent } from './reports/cron/reports.cron.component';
import { AdminAuditReportComponent } from './reports/audit/reports.audit.component';
import { AdminSystemLogReportComponent } from './reports/system-log/reports.system-log.component';
import { SiteAdminAuthViewComponent } from './authentication/admin.authentication.component';
import { AdminSiteNotificationsViewComponent } from './siteNotifications/admin.site-notifications.component';
import { AdminAiFlowComponent } from './aiFlow/admin.ai-flow.component';
import { AdminKnowledgeIndexComponent } from './knowledgeIndex/admin.knowledge-index.component';
import { AdminWebhooksComponent } from './webhooks/admin.webhooks.component';
import { WikiViewHtmlComponent } from '../../../widgets/wiki/view-html/wiki.view-html.component';
import { WikiVersionsComponent } from '../../../widgets/wiki/versions/wiki.versions.component';

import { AdminResolvesService } from './admin-resolves.service';
import { WikiService } from '../../../widgets/wiki/services/wiki.service';
import { WikiHelperService } from '../../../widgets/wiki/services/wiki.helper';

export const ADMIN_STATES: any[] = [
    {
        name: 'home.admin',
        url: 'admin',
        redirectTo: 'home.admin.users',
        resolve: [
            {
                token: 'security',
                deps: [AdminResolvesService],
                resolveFn: async (adminResolvesService: AdminResolvesService) => {
                    return adminResolvesService.security();
                }
            }
        ]
    },
    {
        name: 'home.admin.users',
        url: '/users?page_num&page_size&sort_field&sort_dir&text&status&since&admin',
        reloadOnSearch: false,
        params: {
            page_num: {
                value: '1',
                squash: true
            },
            page_size: {
                value: '20',
                squash: true
            },
            sort_field: {
                value: 'id',
                squash: true
            },
            sort_dir: {
                value: 'desc',
                squash: true
            },
            text: {
                value: '',
                squash: true
            },
            ip: {
                value: '',
                squash: true
            },
            status: {
                value: '',
                squash: true
            },
            since: {
                value: '',
                squash: true
            },
            admin: {
                value: '',
                squash: true
            },
            member: {
                value: '',
                squash: true
            }
        },
        resolve: [
            {
                token: 'tour',
                deps: ['$transition$', AdminResolvesService],
                resolveFn: async (transition: any, adminResolvesService: AdminResolvesService) => {
                    return adminResolvesService.userTour(transition);
                }
            }
        ],
        views: {
            'contentarea@home': {
                component: AdminUsersViewComponent
            }
        }
    },
    {
        name: 'home.admin.users.profile',
        url: '/:unixName',
        redirectTo: 'home.user.userhome'
    },
    {
        name: 'home.admin.users.edit',
        url: '/:unixName/edit?page_num&page_size&sort_field&sort_dir',
        params: {
            page_num: {
                value: '1',
                squash: true
            },
            page_size: {
                value: '20',
                squash: true
            },
            sort_field: {
                value: 'id',
                squash: true
            },
            sort_dir: {
                value: 'desc',
                squash: true
            }
        },
        views: {
            'contentarea@home': {
                component: AdminUserEditComponent
            }
        }
    },
    {
        name: 'home.admin.users.add',
        url: '/add',
        views: {
            'contentarea@home': {
                component: AdminUserAddComponent
            }
        }
    },
    {
        name: 'home.admin.orgs',
        url: '/orgs?isPublic&status&text&selectedProject&page_num&page_size&sort_field&sort_dir',
        params: {
            page_num: {
                type: 'int',
                value: 1,
                squash: true
            },
            page_size: {
                type: 'int',
                value: 20,
                squash: true
            },
            sort_field: {
                value: 'id',
                squash: true
            },
            sort_dir: {
                value: 'asc',
                squash: true
            },
            isPublic: {
                value: null,
                squash: true
            },
            status: {
                value: '',
                squash: true
            },
            text: {
                value: '',
                squash: true
            },
            selectedProject: {
                value: '',
                squash: true
            }
        },
        reloadOnSearch: false,
        views: {
            'contentarea@home': {
                component: SiteAdminOrgsView
            }
        }
    },
    {
        name: 'home.admin.orgs.members',
        url: '/members?search&role&project&membership_type&activity&tab&page_num&page_size&sort_field&sort_dir',
        params: {
            search: { value: '', squash: true },
            role: { value: '', squash: true },
            project: { value: '', squash: true },
            membership_type: { value: '', squash: true },
            activity: { value: '', squash: true },
            tab: { value: 'members', squash: true },
            page_num: { type: 'int', value: 0, squash: true },
            page_size: { type: 'int', value: 20, squash: true },
            sort_field: { value: '', squash: true },
            sort_dir: { value: '', squash: true }
        },
        views: {
            'contentarea@home': {
                component: OrgMembersAuditComponent
            }
        }
    },
    {
        name: 'home.admin.config',
        url: '/config',
        resolve: [
            {
                token: 'tour',
                deps: [AdminResolvesService],
                resolveFn: async (adminResolvesService: AdminResolvesService) => {
                    return adminResolvesService.configTour();
                }
            }
        ],
        views: {
            'contentarea@home': {
                component: AdminConfigComponent
            }
        }
    },
    {
        name: 'home.admin.homepage',
        url: '/homepage',
        params: {
            pageName: {
                value: 'FrontPage',
                squash: true
            }
        },
        resolve: [
            {
                token: 'tour',
                deps: [AdminResolvesService],
                resolveFn: async (adminResolvesService: AdminResolvesService) => {
                    return adminResolvesService.homepageTour();
                }
            },
            {
                token: 'setting',
                deps: [AdminResolvesService],
                resolveFn: async (adminResolvesService: AdminResolvesService) => {
                    return adminResolvesService.homepageSettings();
                }
            }
        ],
        redirectTo: 'home.admin.homepage.options',
        views: {
            'contentarea@home': {
                component: SiteAdminHomepageComponent
            }
        }
    },
    { name: 'home.admin.homepage.options', url: '/options' },
    { name: 'home.admin.homepage.view', url: '/view' },
    { name: 'home.admin.homepage.edit', url: '/edit' },
    { name: 'home.admin.homepage.versions', url: '/versions' },
    {
        name: 'home.admin.scm',
        url: '/scm',
        views: {
            'contentarea@home': {
                component: SiteAdminScmComponent
            }
        }
    },
    {
        name: 'home.admin.cronjobs',
        url: '/cronjobs',
        views: {
            'contentarea@home': {
                component: SiteAdminCronjobsComponent
            }
        }
    },
    {
        name: 'home.admin.trove',
        url: '/categories?:selected',
        reloadOnSearch: false,
        params: {
            selected: {
                type: 'int',
                value: 0,
                squash: true
            }
        },
        resolve: [
            {
                token: 'tour',
                deps: [AdminResolvesService],
                resolveFn: async (adminResolvesService: AdminResolvesService) => {
                    return adminResolvesService.troveTour();
                }
            }
        ],
        views: {
            'contentarea@home': {
                component: AdminTroveViewComponent
            }
        }
    },
    {
        name: 'home.admin.projects',
        url: '/projects?page_num&page_size&sort_field&sort_dir&name&text&status&isPublic&inOrg&projectAdmin&createDate&noActivity&orphaned&isTemplate',
        reloadOnSearch: false,
        params: {
            page_num: {
                value: '1',
                squash: true
            },
            page_size: {
                value: '20',
                squash: true
            },
            sort_field: {
                value: 'id',
                squash: true
            },
            sort_dir: {
                value: 'desc',
                squash: true
            },
            name: {
                value: '',
                squash: true
            },
            text: {
                value: '',
                squash: true
            },
            status: {
                value: '',
                squash: true
            },
            isPublic: {
                value: '',
                squash: true
            },
            inOrg: {
                value: '',
                squash: true
            },
            projectAdmin: {
                value: '',
                squash: true
            },
            createDate: {
                value: '',
                squash: true
            },
            noActivity: {
                value: '',
                squash: true
            },
            orphaned: {
                value: '',
                squash: true
            },
            isTemplate: {
                value: '',
                squash: true
            }
        },
        resolve: [
            {
                token: 'tour',
                deps: [AdminResolvesService],
                resolveFn: async (adminResolvesService: AdminResolvesService) => {
                    return adminResolvesService.projectsTour();
                }
            }
        ],
        views: {
            'contentarea@home': {
                component: AdminProjectsViewComponent
            }
        }
    },
    {
        name: 'home.admin.groups',
        url: '/groups?page_num&page_size&sort_field&sort_dir&text',
        reloadOnSearch: false,
        params: {
            page_num: {
                value: '1',
                squash: true
            },
            page_size: {
                value: '20',
                squash: true
            },
            sort_field: {
                value: 'id',
                squash: true
            },
            sort_dir: {
                value: 'desc',
                squash: true
            },
            text: {
                value: '',
                squash: true
            }
        },
        views: {
            'contentarea@home': {
                component: AdminGroupViewComponent
            }
        }
    },
    {
        name: 'home.admin.snapshots',
        url: '/snapshots?q&page_num&page_size',
        params: {
            page_num: {
                type: 'int',
                value: 1,
                squash: true
            },
            page_size: {
                type: 'int',
                value: 20,
                squash: true
            },
            q: {
                value: '',
                squash: true
            }
        },
        resolve: [
            {
                token: 'tour',
                deps: [AdminResolvesService],
                resolveFn: async (adminResolvesService: AdminResolvesService) => {
                    return adminResolvesService.snapshotsTour();
                }
            }
        ],
        views: {
            'contentarea@home': {
                component: AdminSnapshotsViewComponent
            }
        }
    },
    {
        name: 'home.admin.reports',
        url: '/reports',
        redirectTo: 'home.admin.reports.summary'
    },
    {
        name: 'home.admin.reports.summary',
        url: '/summary',
        views: {
            'contentarea@home': {
                component: SiteSummaryReportComponent
            }
        }
    },
    {
        name: 'home.admin.reports.cron',
        url: '/cron?job&dateRange&dateStart&dateEnd&page_num&page_size&sort_field&sort_dir',
        params: {
            page_num: {
                value: 1,
                type: 'int',
                squash: true
            },
            page_size: {
                value: 50,
                type: 'int',
                squash: true
            },
            sort_field: {
                value: 'id',
                squash: true
            },
            sort_dir: {
                value: 'desc',
                squash: true
            },
            job: {
                value: '',
                squash: true
            },
            dateRange: {
                value: '',
                squash: true
            },
            dateStart: {
                value: '',
                squash: true
            },
            dateEnd: {
                value: '',
                squash: true
            }
        },
        views: {
            'contentarea@home': {
                component: SiteCronHistoryComponent
            }
        }
    },
    {
        name: 'home.admin.reports.audit',
        url: '/audit?section&user&fieldName&dateRange&dateStart&dateEnd&page_num&page_size&sort_field&sort_dir',
        params: {
            page_num: {
                value: 1,
                type: 'int',
                squash: true
            },
            page_size: {
                value: 20,
                type: 'int',
                squash: true
            },
            sort_field: {
                value: 'change_date',
                squash: true
            },
            sort_dir: {
                value: 'desc',
                squash: true
            },
            section: {
                value: '',
                squash: true
            },
            user: {
                value: '',
                squash: true
            },
            fieldName: {
                value: '',
                squash: true
            },
            dateRange: {
                value: '',
                squash: true
            },
            dateStart: {
                value: '',
                squash: true
            },
            dateEnd: {
                value: '',
                squash: true
            }
        },
        views: {
            'contentarea@home': {
                component: AdminAuditReportComponent
            }
        }
    },
    {
        name: 'home.admin.reports.log',
        url: '/log?s&u&p&p1&p2&p3&r&st&end&page_num&page_size&sort_field&sort_dir',
        params: {
            page_num: {
                value: 1,
                type: 'int',
                squash: true
            },
            page_size: {
                value: 20,
                type: 'int',
                squash: true
            },
            sort_field: {
                value: 'logDate',
                squash: true
            },
            sort_dir: {
                value: 'desc',
                squash: true
            },
            s: {
                value: '',
                squash: true
            },
            u: {
                value: '',
                squash: true
            },
            p: {
                value: '',
                squash: true
            },
            p1: {
                value: '',
                squash: true
            },
            p2: {
                value: '',
                squash: true
            },
            p3: {
                value: '',
                squash: true
            },
            r: {
                value: '',
                squash: true
            },
            st: {
                value: '',
                squash: true
            },
            end: {
                value: '',
                squash: true
            }
        },
        views: {
            'contentarea@home': {
                component: AdminSystemLogReportComponent
            }
        }
    },
    {
        name: 'home.admin.authentication',
        url: '/authentication',
        resolve: [
            {
                token: 'tour',
                deps: [AdminResolvesService],
                resolveFn: async (adminResolvesService: AdminResolvesService) => {
                    return adminResolvesService.authTour();
                }
            }
        ],
        views: {
            'contentarea@home': {
                component: SiteAdminAuthViewComponent
            }
        }
    },
    {
        name: 'home.admin.aiflow',
        url: '/aiflow',
        views: {
            'contentarea@home': {
                component: AdminAiFlowComponent
            }
        }
    },
    {
        name: 'home.admin.knowledgeindex',
        url: '/knowledgeindex',
        views: {
            'contentarea@home': {
                component: AdminKnowledgeIndexComponent
            }
        }
    },
    {
        name: 'home.admin.webhooks',
        url: '/webhooks',
        redirectTo: 'home.admin.webhooks.subscriptions',
    },
    {
        name: 'home.admin.webhooks.subscriptions',
        url: '/subscriptions',
        views: {
            'contentarea@home': {
                component: AdminWebhooksComponent
            }
        }
    },
    {
        name: 'home.admin.webhooks.deliveries',
        url: '/deliveries?page_num&page_size&sort_field&sort_dir&subscription_id&event_type&status&date_start&date_end',
        reloadOnSearch: false,
        params: {
            page_num: {
                value: '1',
                squash: true
            },
            page_size: {
                value: '20',
                squash: true
            },
            sort_field: {
                value: 'date',
                squash: true
            },
            sort_dir: {
                value: 'desc',
                squash: true
            },
            subscription_id: {
                value: '',
                squash: true
            },
            event_type: {
                value: '',
                squash: true
            },
            status: {
                value: '',
                squash: true
            },
            date_start: {
                value: '',
                squash: true
            },
            date_end: {
                value: '',
                squash: true
            }
        },
        views: {
            'contentarea@home': {
                component: AdminWebhooksComponent
            }
        }
    },
    {
        name: 'home.admin.sitenotification',
        url: '/notification',
        redirectTo: 'home.admin.sitenotification.history',
        resolve: [
            {
                token: 'tour',
                deps: [AdminResolvesService],
                resolveFn: async (adminResolvesService: AdminResolvesService) => {
                    return adminResolvesService.notificationTour();
                }
            }
        ],
        views: {
            'contentarea@home': {
                component: AdminSiteNotificationsViewComponent
            }
        }
    },
    {
        name: 'home.admin.sitenotification.send',
        url: '/send',
        resolve: [
            {
                token: 'tour',
                deps: [AdminResolvesService],
                resolveFn: async (adminResolvesService: AdminResolvesService) => {
                    return adminResolvesService.notificationTour();
                }
            }
        ],
        views: {
            'contentarea@home': {
                component: AdminSiteNotificationsViewComponent
            }
        }
    },
    {
        name: 'home.admin.sitenotification.history',
        url: '/history?page_size&page_num&sort_field&sort_dir&section&user&subject&dateRange&dateStart&dateEnd',
        params: {
            page_num: {
                value: 1,
                type: 'int',
                squash: true
            },
            page_size: {
                value: 20,
                type: 'int',
                squash: true
            },
            sort_field: {
                value: 'id',
                squash: true
            },
            sort_dir: {
                value: 'desc',
                squash: true
            },
            section: {
                value: '',
                squash: true
            },
            user: {
                value: '',
                squash: true
            },
            subject: {
                value: '',
                squash: true
            },
            dateRange: {
                value: '',
                squash: true
            },
            dateStart: {
                value: '',
                squash: true
            },
            dateEnd: {
                value: '',
                squash: true
            }
        },
        resolve: [
            {
                token: 'tour',
                deps: [AdminResolvesService],
                resolveFn: async (adminResolvesService: AdminResolvesService) => {
                    return adminResolvesService.notificationTour();
                }
            }
        ],
        views: {
            'contentarea@home': {
                component: AdminSiteNotificationsViewComponent
            }
        }
    }
];